/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { SearchPlayer200ResponseResultsInner } from './SearchPlayer200ResponseResultsInner';
import {
    SearchPlayer200ResponseResultsInnerFromJSON,
    SearchPlayer200ResponseResultsInnerFromJSONTyped,
    SearchPlayer200ResponseResultsInnerToJSON,
    instanceOfSearchPlayer200ResponseResultsInner,
} from './SearchPlayer200ResponseResultsInner';

/**
 * 
 * @export
 * @interface SearchPlayer200Response
 */
export interface SearchPlayer200Response {
    /**
     * 
     * @type {Array<SearchPlayer200ResponseResultsInner>}
     * @memberof SearchPlayer200Response
     */
    results?: Array<SearchPlayer200ResponseResultsInner>;
}


/**
 * Check if a given object implements the SearchPlayer200Response interface.
 */
export function instanceOfSearchPlayer200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayer200ResponseFromJSON(json: any): SearchPlayer200Response {
    return SearchPlayer200ResponseFromJSONTyped(json, false);
}

export function SearchPlayer200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayer200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SearchPlayer200ResponseResultsInnerFromJSON)),
    };
}

export function SearchPlayer200ResponseToJSON(value?: SearchPlayer200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SearchPlayer200ResponseResultsInnerToJSON)),
    };
}

